/**
 * @generated SignedSource<<d71f6cf4dc9b87b041b3cbb5b87c8583>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ConfigureDrop_receipt$data = {
  readonly transactionFee: {
    readonly symbol: string;
    readonly unit: string;
    readonly usd: string;
  };
  readonly " $fragmentType": "ConfigureDrop_receipt";
};
export type ConfigureDrop_receipt$key = {
  readonly " $data"?: ConfigureDrop_receipt$data;
  readonly " $fragmentSpreads": FragmentRefs<"ConfigureDrop_receipt">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ConfigureDrop_receipt",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PriceType",
      "kind": "LinkedField",
      "name": "transactionFee",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "unit",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "symbol",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "usd",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TransactionReceiptType",
  "abstractKey": null
};

(node as any).hash = "c8ce61c2d01d2e3e63ed298961866f91";

export default node;
